import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div style={{
          maxWidth: 480, margin: '60px auto', padding: 32, textAlign: 'center',
          background: '#ffebee', borderRadius: 12, border: '1px solid #ef9a9a',
        }}>
          <div style={{ fontSize: '2.5rem', marginBottom: 12 }}>⚠️</div>
          <h2 style={{ color: '#c62828', margin: '0 0 8px 0' }}>Something went wrong</h2>
          <p style={{ color: '#c62828', fontSize: '0.85rem', margin: '0 0 16px 0' }}>
            {this.state.error.message}
          </p>
          <button onClick={() => window.location.reload()} style={{
            padding: '10px 24px', background: '#c62828', color: '#fff',
            border: 'none', borderRadius: 8, fontWeight: 600, cursor: 'pointer',
          }}>
            Reload Page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
